import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import * as $ from "jquery";
import { combineLatest, Subscription } from 'rxjs';
import { ComponentBase } from '../../../base-classes/componet-base';
import { PersonType } from '../../../models/person';
import { PrifactRoute } from '../../../models/prifact-route';
import { Student } from '../../../models/student';
import { UserContext } from '../../../models/user-context';
import { LocalStorageService } from '../../../services/local-storage-service/local-storage.service';
import { RoutingService } from '../../../services/routing-service/routing.service';
import { UserService } from '../../../services/user/user-service/user.service';
import { WardsService } from '../../../services/wards-service/wards.service';
import { AppSettings } from '../../../utils/app-settings';
import { AuthService } from '../../auth/services/auth.service';

declare var openProfile: any
declare var closeProfile: any
declare var platform;

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserProfileComponent extends ComponentBase implements OnInit {

  constructor(private wardsService: WardsService
    , private authService: AuthService
    , private routingService: RoutingService
    , private localStorageService: LocalStorageService
    , private userService: UserService) {
    super();
  }

  wards: Array<Student>;
  selectedProfile: Student;
  subscription: Subscription;
  personType: PersonType;
  @ViewChild('profiles', { static: true }) el: ElementRef;
  //TODO : Record Switcher(after implementation)

  ngOnInit() {
    this.subscription = combineLatest(this.wardsService.wards$, this.wardsService.ward$)
      .subscribe(([wards, ward]) => {
        this.wards = wards;
        this.selectedProfile = ward;
      });
    this.addSubscription(this.subscription);

    let jquery: any = $;
    jquery.fn.clickToggle = function (func1, func2) {
      var funcs = [func1, func2];
      this.data('toggleclicked', 0);
      this.click(function () {
        var data = jquery(this).data();
        var tc = data.toggleclicked;
        jquery.proxy(funcs[tc], this)();
        data.toggleclicked = (tc + 1) % 2;
      });
      return this;
    };

    jquery(this.el.nativeElement).clickToggle(function () {
      openProfile(jquery);
    }, function () {
      closeProfile(jquery);
    });

    let sub = this.userService.getLoggedInUser().subscribe(user => {
      this.personType = user.person.person_type;
    })

  }

  onSelectWard(ward: Student) {
    let sub = this.userService.getLoggedInUser().subscribe(user => {
      let user_context: UserContext = new UserContext();
      user_context.person_id = user.person.person_id;
      user_context.student_id = ward.student_id;
      this.localStorageService.setItem(AppSettings.LocalStorageUserContextKey, user_context);
      this.wardsService.setWard(ward);
      let location = window.location.href.split('#')[0];
      location = location.replace('index.html', '');
      window.location.replace(location + 'index.html');
    });
    this.addSubscription(sub);
  }

  clickedOutside() {
    let jquery: any = $;
    if (jquery('body').hasClass("profile-menu-on")) {
      closeProfile(jquery);
      jquery(this.el.nativeElement).data('toggleclicked', 0);
    }
  }

  logout() {
    this.authService.logout().subscribe(res => {
      if (platform != 'browser') {
        let route = new PrifactRoute();
        route.clear_history = true;
        route.url = "/anonymous/login";
        this.routingService.navigate(route);
      }
    });
  }

  myAccountClicked() {
    this.clickedOutside();
    let route = new PrifactRoute();
    let option;
    if (this.personType == PersonType.Parent) {
      option = 'user'
    }
    else {
      option = 'student'
    }
    route.primary_command = ['pages', 'my-account', option];
    route.append_current_url_to_history = true;
    this.routingService.navigate(route);
  }
}
